import { z } from 'zod';
import { ArtifactSchema } from '../../entities/artifact/artifact.schema';
import { IncludeDeletedRequestSchema } from '../../shared/include-deleted.schema';
/**
 * Show Artifact Request Schema
 * GET /api/v2/artifacts/:id
 */ export const ShowArtifactRequestSchema = IncludeDeletedRequestSchema;
/**
 * Show Artifact Response Schema
 * GET /api/v2/artifacts/:id
 */ export const ShowArtifactResponseSchema = z.object({
    data: ArtifactSchema
});

//# sourceMappingURL=show-artifact.schema.js.map